// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { setForm, cancelSubscription } from '../../actions';
import { SUBSCRIPTIONS_FORM } from '../../constants/forms';
import i18n from '../../i18n/i18n.js';
import Form from '../../ui/components/Forms/Unsubscribe';

type Props = {
    url: string,
    branding: {
        paywall_buttons_bg_color: string,
        paywall_buttons_text_color: string,
    },
    modal: {
        url: string,
        title: string,
        endDate: number,
    },
    language: string,
    cancelSubscription: Function,
    setForm: Function,
};

export class Unsubscribe extends Component<Props> {
    back = () => {
        this.props.setForm(SUBSCRIPTIONS_FORM);
    };

    changeForm = () => {
        this.props.setForm(SUBSCRIPTIONS_FORM);
    };

    unsubscribe = () => {
        return this.props.cancelSubscription(
            this.props.modal.url,
            this.changeForm
        );
    };

    render() {
        const { branding, language, modal, subscriptions, params } = this.props;

        return (
            <Fragment>
                <Form
                    onSubmit={this.unsubscribe}
                    back={this.back}
                    branding={branding}
                    lng={language}
                    modal={modal}
                    params={params}
                    isLoading={subscriptions.isLoadingButton}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        branding: state.branding,
        modal: state.modal,
        language: state.auth.language,
        subscriptions: state.subscriptions,
        params: state.form.unsubscribeForm,
    };
};

export default connect(
    mapStateToProps,
    {
        cancelSubscription,
        setForm,
    }
)(Unsubscribe);



// WEBPACK FOOTER //
// ./src/containers/Forms/Unsubscribe.js